import { FakeContent } from "../../shared/components";
import FechamentoConsumoInfo from "./fechamentoConsumoInfo";
import React from "react";

export const SubHeader = ({
  consumoFormula,
  showContent,
  visualizacao,
  temConsumoObjetivo100KgPv,
}) => {
  if (visualizacao === "g/100kgPV/dia" && !temConsumoObjetivo100KgPv) {
    return null;
  }
  return (
    <FakeContent
      showContent={showContent}
      content={
        <FechamentoConsumoInfo
          consumoFormula={consumoFormula}
          visualizacao={visualizacao}
        />
      }
      height={16}
      width="70%"
    />
  );
};
